
(function (i, s, o, g, r, a, m) {
	i["GoogleAnalyticsObject"] = r;
	i[r] = i[r] || function () {
		(i[r].q = i[r].q || []).push(arguments)
	},
		i[r].l = 1 * new Date();
	a = s.createElement(o),
		m = s.getElementsByTagName(o)[0];
	a.async = 1;
	a.src = g;
	m
		.parentNode
		.insertBefore(a, m)
})(window, document, "script", "https://www.google-analytics.com/analytics.js", "ga");
ga("create", "UA-410611-5", { "cookieDomain": "auto" });
ga("send", "pageview");


// Add borders to mobile menu
let topLi = document.querySelector("#off-canvas-menu > li:first-child");
let bottomLi = document.querySelector("#off-canvas-menu > li:last-child");


topLi.classList.add("border-top");
bottomLi.classList.add("border-bottom");